import React from 'react';

import { hslToHex, hexToHSL } from '../../../helpers/colorConversions';

import SquarePicker from './SquarePicker';
import RangeSlider from '../RangeSlider';

class ColorPicker extends React.Component {
    handleChange = hsl => {
        const { onChange } = this.props;
        onChange(hslToHex(hsl));
    };

    render() {
        const { color, onChange } = this.props;
        const hsl = hexToHSL(color);

        const sliderStyle = {
            marginTop: '1rem',
            marginBottom: '1rem'
        };
        return (
            <div>
                <SquarePicker color={color} colors={['ed225d', '2195f1', '38c92b', 'fff200', '502739']} onChange={onChange} />
                <RangeSlider
                    min={0}
                    max={359}
                    step={0.1}
                    currentValue={hsl.h}
                    onChange={h => this.handleChange({ ...hsl, h })}
                    background="linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)"
                    hideValues
                    style={sliderStyle}
                />
                <RangeSlider
                    min={0}
                    max={100}
                    step={0.1}
                    currentValue={hsl.s}
                    onChange={s => this.handleChange({ ...hsl, s })}
                    background={`linear-gradient(to right, #808080 0%, hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%) 100%`}
                    hideValues
                    style={sliderStyle}
                />
                <RangeSlider
                    min={0}
                    max={100}
                    step={0.1}
                    currentValue={hsl.l}
                    onChange={l => this.handleChange({ ...hsl, l })}
                    background={`linear-gradient(to right, #000 0%, hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%) 50%, #fff 100%)`}
                    hideValues
                    style={sliderStyle}
                />
            </div>
        );
    }
}

export default ColorPicker;
